export default __webpack_public_path__ + "static/media/dialyysi-darkblue.bdd9737f.svg";